import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import { styled } from 'linaria/react';
import React from 'react';
import { useQuery } from 'react-apollo';
import striptags from 'striptags';
import CategoryLink from '@jetshop/ui/CategoryLink';
import Image from '@jetshop/ui/Image';
import inspirationPosts from './InspirationPosts.gql';

import { Shortcodes } from '@jetshop/flight-shortcodes';
import Row from '../Shortcodes/Row.js';
import Column from '../Shortcodes/Column.js';
import { Image as ShortcodeImage } from '../Shortcodes/Image';
import TextLink from '../Shortcodes/TextLink';
import CompImage from '../Shortcodes/CompImage';
import ShortcodeContent from '../Shortcodes/Content';
import Intro from '../Shortcodes/Intro';
import { theme } from '../Theme';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  max-width: 1288px;
  padding: 0 20px;
  margin: 10px auto;
  ${theme.below.lg} {
  }
  li:last-child {
    &:after {
      display: none;
    }
  }
`;

const Content = styled('div')`
  margin: auto;
  display: block;
  width: 100%;
  margin: 0 auto 0 auto;

  ${theme.below.lg} {
    margin-top: 5px;
  }

  h1 {
    font-size: 2.5rem;
    line-height: 0.9;
    margin-bottom: 0.5rem;
  }
  h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  p {
    margin-bottom: 2rem;
  }
  h2,
  h3,
  h4,
  h5 {
    line-height: 0.9;
    ${theme.below.lg} {
      line-height: 1;
    }
  }
`;
const InspirationItemsWrapper = styled('div')`
  max-width: 80rem;
  margin: auto;
  padding: 0 1.5rem;
  margin-top: 5rem;
  ${theme.below.lg} {
    margin-top: 2rem !important;
  }
`;
const CategoryList = styled('ul')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
`;
const CategoryItem = styled('li')`
  padding: 1rem 0.5rem;
  width: 20%;

  &.large {
    width: 50%;

    a {
      text-align: left;
    }

    .category-content {
      padding: 0 30px 40px 30px;
      position: relative;
      margin-top: -33px;

      p {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.03em;
      }
    }

    h2 {
      font-size: 3.5rem;
      letter-spacing: 0.01em;
      line-height: 0.9;
      margin-top: 0;
      margin-bottom: 30px;
    }
  }
  a {
    display: block;
    text-decoration: none;
    color: black;
    text-align: center;
  }
  h2 {
    margin-top: 0.75em;
    font-size: 14px;
    color: black;
    font-weight: 600;
    letter-spacing: 0.03em;
  }
`;

export const InspirationItems = ({ category, showLargePosts }) => {
  const { data, loading, error } = useQuery(inspirationPosts, {
    variables: {
      id: category.id
    }
  });
  if (loading || error) return null;
  return (
    <InspirationItemsWrapper>
      <CategoryList>
        {data.category.subcategories.map((category, index) => (
          <CategoryItem
            key={index}
            className={showLargePosts && index < 2 ? 'large' : 'small'}
          >
            <CategoryLink category={category}>
              <Image
                aspect={'4:5'}
                cover
                src={
                  category.images?.length > 0
                    ? category.images
                    : 'https://posterstore.se/images/zoom/mintwallbike1.jpeg'
                }
                alt={category.name}
                sizes={'600'}
              />
              <div className="category-content">
                <h2>{category.name}</h2>
                {showLargePosts && index < 2 ? (
                  <p
                    className="category-excerpt"
                    dangerouslySetInnerHTML={{
                      __html:
                        striptags(category?.content?.replace(/\[(.*?)\]/g, ''))
                          .split(' ')
                          .slice(0, 80)
                          .join(' ') + '...'
                    }}
                  />
                ) : null}
              </div>
            </CategoryLink>
          </CategoryItem>
        ))}
      </CategoryList>
    </InspirationItemsWrapper>
  );
};

function InspirationPage(props) {
  const { category, parents } = props;
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents
  };
  return (
    <Content>
      <StyledBreadcrumbs {...breadcrumbProps} />
      <Shortcodes
        content={category.content}
        components={{
          Image: ShortcodeImage,
          CompImage: CompImage,
          Row: Row,
          Column: Column,
          TextLink: TextLink,
          Content: ShortcodeContent,
          Intro: Intro
        }}
      />
    </Content>
  );
}

export default InspirationPage;
